import { render, staticRenderFns } from "./edit_selection.vue?vue&type=template&id=1b118060&scoped=true&"
import script from "./edit_selection.vue?vue&type=script&lang=js&"
export * from "./edit_selection.vue?vue&type=script&lang=js&"
import style0 from "./edit_selection.vue?vue&type=style&index=0&id=1b118060&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b118060",
  null
  
)

export default component.exports